module.exports = __webpack_public_path__ + "static/media/sandrele-reis.a2e4a2f5.jpg";